export default async function init() {
    const { TorusConnector } = await import("@web3-react/torus-connector")
    return {
        web3ReactConnector({ chainId, initOptions, constructorOptions }) {
            return new TorusConnector({ chainId, constructorOptions, initOptions })
        }
    }
}
